<template>
    <v-ons-page>
        <div class="content">
            <v-ons-list v-for="(dayWithEvents, index) in groupedEvents" :key="index">
                <v-ons-list-header>{{dayWithEvents.start_date | fullDateStartTime}}</v-ons-list-header>
                <v-ons-list-item v-for="event in dayWithEvents.events" :key="event.id">
                    <div class="qf-calendar-item-wrapp">
                        <div class="left qf-calendar-time">
                            <span v-if="event.start_time" class="qf-cal-event-time">{{event.start_time | truncatedStartTime}}</span>
                            <span v-else class="qf-cal-event-time">All<br>Day</span>
                            <span v-if="event.end_time && event.end_time !== event.start_time" class="qf-cal-event-time">{{event.end_time | truncatedStartTime}}</span>
                        </div>
                        <div class="center qf-calendar-details" @click="openEventDetails(event, dayWithEvents.start_date)">
                            <h4 class="list-item__title">{{event.title}}</h4>
                            <div v-if="event.related_item" class="qf-related-item list-item__subtitle">
                                <p class="list-item__subtitle">
                                    <v-ons-icon icon="fa-link"></v-ons-icon>
                                    <span class="qf-highlight">{{event.related_item.title}}</span>
                                </p>
                            </div>
                            <div v-if="event.location" class="qf-event-location list-item__subtitle">
                                <p><v-ons-icon icon="fa-map-marker"></v-ons-icon> {{event.location}}</p>
                            </div>
                        </div>
                    </div>
                </v-ons-list-item>
            </v-ons-list>
        </div>
        <qf-spinner :showing="loadingData" message="Updating contents..."></qf-spinner>
    </v-ons-page>
</template>

<script>
    import Api from '@/services/api';
    import moment from 'moment';
    import SingleEvent from "../singleViews/SingleEvent";
    import Login from "../login/Login";
    import QfSpinner from "../shared/QfSpinner";

    export default {
        name: 'DashboardCalendar',
        components: {QfSpinner},
        data() {
            return {
                title: 'Latest from projects',
                upcomingEvents: [],
                groupedEvents: [],
                token: '',
                baseUrl: process.env.VUE_APP_BASE_URL,
                loadingData: false
            }
        },
        mounted() {
            this.token = this.$getCookie('access_token');
            let self = this;
            if(this.token){
                Api().get('/dashboard/events').then(response => {
                    self.upcomingEvents = response.data;
                    self.groupedEvents = self.groupEvents(self.upcomingEvents);
                    //console.log("Grouped events: ", self.groupedEvents);
                }).catch(() => {
                    self.$handleReject();
                    self.goToLogin();
                });
            }else{
                self.$handleReject();
                self.goToLogin();
            }
        },
        computed: {
            defaultProjectLogo(){
                return `https://`+process.env.VUE_APP_VARIANT+`.capecloud.ch/images/placeholder-logo.png`
            }
        },
        methods: {
            getEventByDate(dateString, eventsArr) {
                let event = eventsArr.find(item => item.closestNextOccurrance === dateString);
                if(event){
                    return event
                }else {
                    return false;
                }
            },
            round(number){
                return Math.round(number*100)/100
            },
            goToLogin(){
                this.$store.commit('navigator/replace', {
                    extends: Login,
                    data() {
                        return {
                            bounced: true
                        };
                    }
                });
            },
            eligibleEventsOnly(singleEvent){

                let now = moment(new Date());
                let eventStart = singleEvent.start_date;

                if(singleEvent.start_time) {
                    eventStart = eventStart + ' '+singleEvent.start_time;
                }

                let eventTime = moment(eventStart);

                //let eventDistance = now.diff(eventTime,'days');

                if(moment(eventStart).isAfter(now)){
                    singleEvent.closestNextOccurrance = eventStart;
                    return singleEvent;
                }
                else if(singleEvent.repeat && (moment(singleEvent.stop_repeating_date).isAfter(now) || singleEvent.is_continuous))
                {

                    //If interval is set to weeks, convert back to days
                    if(singleEvent.repeat === 'week') {
                        singleEvent.repeat = 'day';
                        singleEvent.frequency = singleEvent.frequency * 7;
                    }

                    //Prettify for console.log
                    //let period = singleEvent.frequency + ' '+ singleEvent.repeat+'(s)';

                    //Add s for .add operation further down
                    let periodUnit = singleEvent.repeat+'s';


                    let referenceNow;
                    switch (singleEvent.repeat) {
                        default:
                            referenceNow = now;
                            break;
                        case "month":
                            referenceNow = moment(now.format('YYYY-MM')+'-'+eventTime.format('DD'));
                            break;
                        case "year":
                            referenceNow = moment(now.format('YYYY')+'-'+eventTime.format('MM-DD'));
                            break;
                    }

                    //Get distance between now and original start date in the past
                    let temporalDistance = referenceNow.diff(eventTime,singleEvent.repeat, true);
                    //let originalReference = referenceNow.clone();
                    //Remaining interval to closest next event
                    let remIntToNextEvent = (temporalDistance % singleEvent.frequency)*singleEvent.frequency;
                    //debugger;
                    if(remIntToNextEvent < 1 && remIntToNextEvent >=0) {
                        if(singleEvent.repeat == 'year' && referenceNow.isAfter(now)) {
                            remIntToNextEvent = 0;
                        }else{
                            remIntToNextEvent = 1;
                        }
                    }else {
                        remIntToNextEvent = Math.floor(remIntToNextEvent);
                    }

                    let expectedNextDate = referenceNow.add(remIntToNextEvent, periodUnit).format('YYYY-MM-DD');
                    /*
                    console.log("Event ", singleEvent.title, singleEvent);
                    console.log("Start: ", eventStart, " | Repeat every: ", period);
                    console.log("Ref. Now: ", originalReference.format('YYYY-MM-DD'), " | Temporal Distance "+(temporalDistance % singleEvent.frequency)+' '+ periodUnit+" | Time to add to next event: ",  remIntToNextEvent , ' '+periodUnit);
                    console.log(" | Next event after: ",  Math.round((singleEvent.frequency - (temporalDistance % singleEvent.frequency))*100)/100);
                    console.log("Expected next event date: ", expectedNextDate);
                    console.log("===============");
                    */
                    singleEvent.closestNextOccurrance = expectedNextDate;
                    return singleEvent;
                }
                else{
                    return false;
                }


                //debugger;
                //if(singleEvent.start_date > )
            },
            groupEvents(eventsArr){
                let eventsByDate = [];
                let self = this;

                if(eventsArr.length > 0){
                    eventsArr.forEach(function(item){
                        let processedEvent = self.eligibleEventsOnly(item);
                        if(processedEvent){
                            let selectedDate = self.getEventByDate(item.closestNextOccurrance, eventsByDate);
                            //debugger;
                            let indx;
                            if(!selectedDate){
                                let newSelectedDate = {
                                    start_date: item.closestNextOccurrance,
                                    events: []
                                };
                                eventsByDate.push(newSelectedDate);
                                indx = eventsByDate.length - 1;
                            }else {
                                indx = eventsByDate.indexOf(selectedDate);
                            }
                            eventsByDate[indx].events.push(item);
                        }
                    });
                }

                eventsByDate.sort((a, b) => (a.start_date > b.start_date) ? 1 : -1);

                return eventsByDate;
            },
            openEventDetails(event, onDate){

                let viewData = {
                    toolbarInfo: {
                        backLabel: 'Back to events list',
                        title: 'Event Details'
                    },
                    eventData: event,
                    onDate: onDate
                };

                this.$store.commit('navigator/push', {
                    extends: SingleEvent,
                    data() {
                        return viewData;
                    }
                });
            }
        },

        filters: {
            momentStartTime: function (date) {
                return moment(date).format('HH:mm');
            },
            truncatedStartTime: function (time) {
                if(time){
                    return time.substring(0, 5);
                }else {
                    return '';
                }

            },
            fullDateStartTime: function (date) {
                return moment(date).format('ddd, Do of MMM YYYY');
            },
        },
    }
</script>

<style>
    .qf-cal-event-time {
        font-size: 0.75em;
    }

    .qf-cal-event-time {
        text-align: center;
        line-height: 1.4em;
        text-transform: uppercase;
        font-weight: 600;
    }

    .qf-calendar-item-wrapp {
        display: flex;
        width: 100%;
        align-items: center;
    }
    .qf-calendar-time {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        min-width: 50px;
    }

    .qf-cal-event-time:not(:last-of-type) {
        margin-bottom: 8px;
    }

    .qf-calendar-details h4 {
        margin: 0;
        font-size: 1em;
        font-weight: 600;
    }

    .qf-calendar-details .list-item--material__subtitle {
        margin: 0;
        margin-top: 10px;
    }

    .qf-calendar-details  .ons-icon.fa {
        margin-right: 5px;
    }

    .qf-event-location {
        margin: 0;
    }

    .qf-event-location p {
        margin: 0;
    }

</style>
